import axios from '../../axios';

export default {
  namespaced: true,
  state: {
    // allRegions: []
  },
  getters: {
    allRegions: (state, getters, rootState, rootGetters) => {
      if (rootGetters['countries/allCountries'] && rootGetters['countries/allCountries'].length > 1) {
        const regions = [];
        rootGetters['countries/allCountries'].filter((c) => c.regions && c.regions.length > 0).forEach((cr, key) => {
          regions.push(...cr.regions);
        });
        // remove duplicates
        return regions.filter((v, i, a) => a.findIndex((t) => (t.id === v.id)) === i);
      }
    },
    allSubRegions: (state, getters, rootState, rootGetters) => {
      if (getters.allRegions) {
        const subRegions = [];
        getters.allRegions.forEach((r, key) => {
          subRegions.push(...r.subRegions);
        });
        return subRegions;
      }
    },
    getRegionById: (state, getters, rootState, rootGetters) => (id) => {
      if (getters.allRegions) {
        return getters.allRegions.find((o) => o.id === id);
      }
    },
    getRegionNameBydId: (state, getters, rootState, rootGetters) => (id) => {
      if (getters.allRegions) {
        const region = getters.allRegions.find((o) => o.id === id);
        if (region) return region.description;
      }
    },
    getSubRegionById: (state, getters, rootState, rootGetters) => (id) => {
      if (getters.allSubRegions) {
        return getters.allSubRegions.find((sr) => sr.id === id);
      }
    },
  },
  mutations: {
    // setAllRegions(state, regions) {
    //  state.allRegions = regions
    // }
  },
  actions: {
    // fetchAllRegions({ commit, dispatch, getters }) {
    //  axios.get('/core/regions/live')
    //    .then(res => {
    //      commit('setAllRegions', res.data)
    //    })
    //    .catch(error => console.log(error))
    // },
  },
};
